import clsx from 'clsx'

import { Link } from '@/components/CustomLink'
import { Warning } from '@/components/Warning'

import { useEntry } from '../Person.hooks'

type Props = {
	className?: string
}

export function PersonRelatedNews({ className }: Props) {
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={className}>{entry.error}</Warning>
	}

	return (
		<ul data-testid="person-related-news" className={clsx('list-disc pl-5 mt-5', className)}>
			{entry.data?.additionalOptions?.relatedNewsCollection?.items.map((item) => {
				return (
					item && (
						<li
							key={item.sys.id}
							className="hover:text-bc-blue text-gray-600 marker:text-gray-600 text-md leading-relaxed"
						>
							<Link
								href={item.url ?? '#'}
								className="underline decoration-1 underline-offset-4 decoration-bc-blue py-0.5"
							>
								{item.internalName}
							</Link>
						</li>
					)
				)
			})}
		</ul>
	)
}
